import Footer from "../../Components/Common/Footer";
import Header from "../../Components/Common/Header";

const MainLayout = ({ children }) => {
    return (
        <>
            <Header />
            <div className="container">
                {children}
            </div>
            <Footer />

        </>
    );
}

export default MainLayout;